import * as React from 'react';

import { ParameterInputComponentProps, useParameterType } from './ParameterTypes';

const TypeSpecificParameterInput = ({ parameter, onChange, onBlur, value, searchId }: ParameterInputComponentProps) => {
  const { component: Component } = useParameterType(parameter?.type);

  return <Component parameter={parameter} value={value} onChange={onChange} onBlur={onBlur} searchId={searchId} />;
};

export default TypeSpecificParameterInput;
